import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import { Answer } from './types/Answer';
import './assets/fonts/Montserrat-SemiBold-normal.js';
import './assets/fonts/SourceSansPro-Regular-normal.js';
export class PdfExporter {
    constructor(questionnaire, state) {
        this.questionnaire = questionnaire;
        this.state = state;
        this.cursor = { x: 42, y: 42 };
    }
    async exportAsPdf() {
        this.document = new jsPDF({
            unit: 'pt',
        });
        this.document.setFont('SourceSansPro-Regular', 'normal');
        this.document.setTextColor('#525A5D');
        for (const [i, field] of this.questionnaire.fields.entries()) {
            this.writeSpace(15);
            this.writeText(`Handlungsfeld ${i + 1}: ${field.title}`, 18, 'Montserrat-SemiBold');
            this.writeText(field.description, 11);
            this.writeSpace(10);
            for (const [j, section] of field.sections.entries()) {
                for (const [k, subsection] of section.subsections.entries()) {
                    const head = [];
                    if (j === 0) {
                        head.push([
                            {
                                content: `${i + 1}.${j + 1}`,
                                styles: {
                                    fillColor: '#98a1a6',
                                    textColor: '#ffffff',
                                },
                            },
                            {
                                content: section.description,
                                colSpan: 6,
                                styles: {
                                    fillColor: '#ffffff',
                                    textColor: '#6d767c',
                                    halign: 'left',
                                },
                            },
                        ]);
                    }
                    head.push([
                        {
                            content: `${i + 1}.${j + 1}.${k + 1}`,
                            styles: {
                                fillColor: '#005e3f',
                                textColor: '#ffffff',
                            },
                        },
                        {
                            content: subsection.description,
                            styles: {
                                textColor: '#005e3f',
                                halign: 'left',
                            },
                        },
                        'ja',
                        'eher ja',
                        'eher nein',
                        'nein',
                        'nicht relevant',
                    ]);
                    this.writeTable({
                        head,
                        body: subsection.statements.map((st, i) => [
                            {
                                content: String.fromCharCode(65 + i),
                                styles: {
                                    font: 'Montserrat-SemiBold',
                                    textColor: '#6d767c',
                                },
                            },
                            {
                                content: st.description,
                                styles: {
                                    halign: 'left',
                                },
                            },
                            this.state[st.uuid].answer === Answer.Yes ? '◉' : '',
                            this.state[st.uuid].answer === Answer.MostlyYes ? '◉' : '',
                            this.state[st.uuid].answer === Answer.MostlyNo ? '◉' : '',
                            this.state[st.uuid].answer === Answer.No ? '◉' : '',
                            this.state[st.uuid].answer === Answer.NotRelevant ? '◉' : '',
                        ]),
                    });
                }
            }
        }
        this.document.save('Selbstcheck-Ergebnis.pdf');
    }
    insertNewPageIfRequired(height) {
        if (this.cursor.y + height > 800) {
            this.document.addPage();
            this.cursor.y = 42;
        }
    }
    writeSpace(height) {
        this.insertNewPageIfRequired(height);
        this.cursor.y = this.cursor.y + height;
    }
    writeText(text, fontSize = 13, fontFamily = 'SourceSansPro-Regular', options = {}) {
        var _a;
        const fontSizeMm = fontSize;
        const lineHeight = fontSizeMm * ((_a = options.lineHeightFactor) !== null && _a !== void 0 ? _a : 1.15);
        this.document.setFontSize(fontSize);
        this.document.setFont(fontFamily);
        const lines = this.document.splitTextToSize(text, 511);
        const height = lineHeight * lines.length + lineHeight / 2;
        this.insertNewPageIfRequired(height);
        this.document.text(lines, this.cursor.x, this.cursor.y + lineHeight, options);
        this.cursor.y = this.cursor.y + height;
    }
    writeTable(options) {
        var _a;
        options.startY = this.cursor.y;
        if (!options.headStyles)
            options.headStyles = {};
        if (!options.styles)
            options.styles = {};
        if (!options.bodyStyles)
            options.bodyStyles = {};
        if (!options.headStyles.font)
            options.headStyles.font = 'Montserrat-SemiBold';
        if (!options.bodyStyles.font)
            options.bodyStyles.font = 'SourceSansPro-Regular';
        if (!options.headStyles.fillColor)
            options.headStyles.fillColor = '#ffffff';
        if (!options.headStyles.textColor)
            options.headStyles.textColor = '#525A5D';
        if (!options.bodyStyles.textColor)
            options.bodyStyles.textColor = '#525A5D';
        if (!options.styles.halign)
            options.styles.halign = 'center';
        if (!options.alternateRowStyles)
            options.alternateRowStyles = {};
        if (!options.alternateRowStyles.fillColor)
            options.alternateRowStyles.fillColor = '#efefef';
        autoTable(this.document, options);
        //@ts-ignore
        this.cursor.y = (_a = this.document.lastAutoTable) === null || _a === void 0 ? void 0 : _a.finalY;
    }
}
